import React, { useMemo, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import { useOnSubmitFormik } from "api/hooks/useOnSubmitFormik";
import { Collections } from "api/model/Collections";
import { BoxCard } from "ui/componentes/BoxCard";
import * as Yup from "yup";
import {
    Box,
    Button,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
} from "@material-ui/core";
import { SubmitButton } from "ui/componentes/SubmitButton";
import { Track, TrackFormDefault } from "api/model/Track";
import { InputFieldFormik } from "ui/componentes/Form/InputFieldFormik";
import { AddBox } from "@material-ui/icons";
import { TrackCoursesFormList } from "ui/views/TracksView/TrackCoursesFormList";

interface TrackFormProps {
    track?: Track;
    onCancel: () => void;
}

export const TrackFormValidation = Yup.object().shape({});

const TrackForm: React.FC<TrackFormProps> = ({ onCancel, track }) => {
    const onSubmit = useOnSubmitFormik<Track>(Collections.TRACKS);
    const formValues = useMemo<Track>(() => track || TrackFormDefault, [track]);
    const [courseName, setCourseName] = useState("");

    return (
        <Formik
            enableReinitialize={true}
            initialValues={formValues}
            onSubmit={onSubmit}
            validationSchema={TrackFormValidation}
        >
            {({ values, submitForm, resetForm }) => {
                return (
                    <Form>
                        <BoxCard display="flex">
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <InputFieldFormik
                                                id="name"
                                                name="name"
                                                label="Nome"
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <InputFieldFormik
                                                id="friendlyName"
                                                name="friendlyName"
                                                label="Nome comercial"
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <InputFieldFormik
                                                id="country"
                                                name="country"
                                                label="Pais"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputFieldFormik
                                                id="description"
                                                name="description"
                                                label="Descrição"
                                                multiline
                                                rows={4}
                                                helperText={`Max.: ${values.description?.length} / 200`}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FieldArray name="courses">
                                                {({ push }) => {
                                                    return (
                                                        <TextField
                                                            label="Traçado"
                                                            value={courseName}
                                                            onChange={(e) =>
                                                                setCourseName(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            color="primary"
                                                                            onClick={() => {
                                                                                if (
                                                                                    !courseName
                                                                                )
                                                                                    return;
                                                                                push(
                                                                                    {
                                                                                        name: courseName,
                                                                                    }
                                                                                );
                                                                                setCourseName(
                                                                                    ""
                                                                                );
                                                                            }}
                                                                        >
                                                                            <AddBox />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            </FieldArray>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <TrackCoursesFormList />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box
                                        display="flex"
                                        flexDirection="row-reverse"
                                        justifyContent=""
                                    >
                                        <SubmitButton
                                            style={{
                                                marginLeft: 5,
                                            }}
                                            fullWidth={false}
                                        >
                                            Salvar
                                        </SubmitButton>
                                        <Button
                                            fullWidth={false}
                                            onClick={() => {
                                                resetForm();
                                                onCancel();
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </BoxCard>
                    </Form>
                );
            }}
        </Formik>
    );
};

export { TrackForm };
